import de from '../JsonLang/de.json'
export const lang = { ...de }